import http from '@/requests/http'

class Announcements {
  static all (params) {
    return http.post('announcements', params)
  }

  static add (params) {
    return http.post('announcements/add', params)
  }

  static update (params) {
    return http.post('announcements/update', params)
  }

  static view (params) {
    return http.post('announcements/view', params)
  }

  static destroy (params) {
    return http.post('announcements/destroy', params)
  }
}

export default Announcements
